import './index.scss';

interface Data {
  name?: string;
  num?: string;
  img?: string;
  color?: string;
  color1?: string;
}

interface IEchartsBubbleParams {
  data?: {
    title?: string;
    list?: Data[];
    time?: string;
  };
}

const getImgOrDotHTMLStr = (img?: string, color?: string): string => {
  if (img) return `<img class="dbg-echarts-bubble-img" src="${img}" />`;
  return getDotHTMLStr(color);
};

const getDotHTMLStr = (color?: string): string => {
  if (!color) return '';
  return `<span style="background-color: ${color}" class="dbg-echarts-bubble-color"></span>`;
};

const EchartsBubble = (params?: IEchartsBubbleParams): string => {
  const { data } = params || {};
  const { title, list, time } = data || {};

  const listHTMLStrs = list?.map((item) => {
    const { name, num, img, color, color1 } = item || {};

    return `
      <div class="dbg-echarts-bubble-tr">
        <div class="dbg-echarts-bubble-col">
          ${getImgOrDotHTMLStr(img, color1)}
          ${getDotHTMLStr(color)}
          <span class="dbg-bubble-text">${name}</span>
        </div>
        <div class="dbg-echarts-bubble-col dbg-bubble-num">${num}</div>
      </div>
    `;
  });

  return `
    <div class="dbg-echarts-bubble">
      <div class="dbg-echarts-bubble-tr dbg-bubble-header">
        <div class="dbg-echarts-bubble-col">${time}</div>
        <div style="padding-left: 5px" class="dbg-echarts-bubble-col">${title}</div>
      </div>
      ${listHTMLStrs?.join('') || ''}
    </div>
  `;
};

export default EchartsBubble;
